
import { Card } from "@shared/ui/card";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import WorkFlowDetails from "../workflowDetails/workFlowDetails";
import PerformanceMetrics from "../performanceMetrics/performanceMetrics";
import QuickAction from "../QuickAction/quickAction";
import ExecutionHistoryLanding from "../tabs/executionHistory/landing/landing";
import { useGetWorkflowDetails } from "@features/ux/components/workflow/hooks";
import ChannelCommunicationLanding from "../tabs/communicationChannel/landing/landing";
import { NotesTab } from "@features/ux/components/shared/components/notesTab";
import { ActivityLogTab } from "@features/ux/components/shared/components/activityLog";

const WorkflowsDetailsLanding = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();
  const { data: workflowDetail } = useGetWorkflowDetails(Number(id));
  return (
    <div>
      <div className="flex items-center gap-4">
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700 hover:text-gray-900"
          onClick={() => navigate("/communication-hub/workflows")}
        />
        <div className="flex flex-col">
          <PageHeader
            title="View Workflow"
            subtitle="Preview and verify your workflow content"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <Card className="col-span-8 mt-4">
          <WorkFlowDetails workflowDetail={workflowDetail} />
        </Card>
        <div className="col-span-4 mt-4">
          <PerformanceMetrics workflowDetail={workflowDetail} />
          <Card className="mt-4">
            <QuickAction  />
          </Card>
        </div>
      </div>
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="executionHistory"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-4 mb-6 p-1"
            urlMapping={{
              executionHistory: "executionHistory",
              communicationChannel: "communicationChannel",
              notes: "notes",
              activityLog: "activityLog",
            }}
            tabComponents={{
              executionHistory: {
                label: "Execution History",
                component: <ExecutionHistoryLanding />,
              },
              communicationChannel: {
                label: "Communication Channel",
                component: <ChannelCommunicationLanding workflowDetail={workflowDetail} />,
              },
              notes: {
                label: "Notes",
                component: (
                  <NotesTab
                    requestId={id}
                    source="3"
                  />
                ),
              },
              activityLog: {
                label: "Activity Log",
                component: <ActivityLogTab entityId={id} entityType="3" />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkflowsDetailsLanding;
